import {
  GET_ALL_BONUSES,
  GET_ALL_BONUSES_RESPONSE_SUCCESS,
  CREATE_BONUS,
  UPDATE_BONUS,
  DELETE_BONUS,
} from "./actionTypes"

export const getAllBonuses = () => {
  return {
    type: GET_ALL_BONUSES,
  }
}
export const getAllBonusesResponseSuccess = payload => ({
  type: GET_ALL_BONUSES_RESPONSE_SUCCESS,
  payload: payload,
})

// ------------------------------------- CREATE --------------------------------------------------------

export const createBonus = (payload, history) => {
  return {
    type: CREATE_BONUS,
    payload: payload,
    history,
  }
}

// ------------------------------------- EDIT --------------------------------------------------------

export const updateBonus = (payload, history, redirectTo) => {
  return {
    type: UPDATE_BONUS,
    payload: payload,
    history,
    redirectTo,
  }
}

// ------------------------------------- DELETE --------------------------------------------------------

export const deleteBonus = payload => ({
  type: DELETE_BONUS,
  payload: payload,
})
